import React, { useMemo, useRef, useState, useEffect } from 'react';
import { Virtuoso } from 'react-virtuoso';
import AddAction from './AddAction';

const ActionsRender = React.memo(({
  actionList,
  handleInputChange,
  handleDeleteAction,
  handleDeleteActionCancel,
  handleDeleteActionConfirmation,
  ratingsData,
  iconsData,
  setRatingsData,
  setIconsData,
}) => {
  const sortedActions = useMemo(
    () =>
      actionList
        .slice()
        .sort((a, b) => a.actionIndex - b.actionIndex)
        .filter(x => x.isDelete !== true),
    [actionList]
  );

  const wrapperRef = useRef(null);
  const [scrollParent, setScrollParent] = useState(undefined);

  useEffect(() => {
    if (!wrapperRef.current) return;
    let el = wrapperRef.current.parentElement;
    while (el) {
      const { overflow, overflowY } = window.getComputedStyle(el);
      if (/scroll|auto/.test(overflow + overflowY)) {
        setScrollParent(el);
        return;
      }
      el = el.parentElement;
    }
  }, []);

  return (
    <div ref={wrapperRef}>
      <Virtuoso
        customScrollParent={scrollParent}
        overscan={600}
        data={sortedActions}
        itemContent={(_index, rec) => (
          <AddAction
            action={rec}
            currentIndex={rec.actionIndex}
            handleInputChange={handleInputChange}
            handleDeleteAction={handleDeleteAction}
            handleDeleteActionCancel={handleDeleteActionCancel}
            handleDeleteActionConfirmation={handleDeleteActionConfirmation}
            ratingsData={ratingsData}
            iconsData={iconsData}
            setRatingsData={setRatingsData}
            setIconsData={setIconsData}
          />
        )}
      />
    </div>
  );
}, (prevProps, nextProps) =>
  prevProps.actionList === nextProps.actionList &&
  prevProps.ratingsData === nextProps.ratingsData &&
  prevProps.iconsData === nextProps.iconsData
);

export default ActionsRender;
